import { createContext } from "react";

export const MediaContext = createContext({
    isDesktop: false,
});

export default MediaContext;
